import { render } from "./pop-up.vue?vue&type=template&id=73b6e2e0&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-73b6e2e0"

export default script